/**
 * Sanitize search string to prevent potential injection attacks
 * Removes potentially dangerous characters and trims whitespace
 * @param input - The input string to sanitize
 * @returns The sanitized string
 */
export function sanitizeSearchString(input: string): string {
  return input.replace(/[<>{}]/g, '').trim();
}
